var _defs, _g, _path, _g2, _g3, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEfsaLogo = function SvgEfsaLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 611.84 204.01",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#1f3c88;}.cls-3{fill:#36b190;}.cls-4{fill:#f8b010;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M163.48,79.35c0,45.07-36.67,81.74-81.74,81.74S0,124.42,0,79.35H28.46c0,29.38,23.9,53.28,53.28,53.28s53.28-23.9,53.28-53.28h28.46Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.69,123.14c24.15,0,43.8-19.65,43.8-43.8,0-11.15-4.2-21.34-11.08-29.08-6.22,6.51-13.75,15.68-20.43,27.84-6.46,11.74-10.12,22.61-12.29,31.02-4.45-5.3-11.29-12.29-21.03-18.62-8.52-5.55-16.55-8.82-22.76-10.82,.18,23.99,19.75,43.46,43.79,43.46Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M135.78,23.38c.56,.18,1.15-.13,1.33-.69s-.13-1.15-.69-1.33-1.15,.13-1.33,.69,.13,1.15,.69,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.78,15.78c-.61-.19-1.26,.14-1.45,.75s.14,1.26,.75,1.45c.61,.19,1.26-.14,1.45-.75s-.14-1.26-.75-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.55,11.02c-.63-.2-1.31,.15-1.51,.78s.15,1.31,.78,1.51,1.31-.15,1.51-.78-.15-1.31-.78-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.86,7.06c-.66-.21-1.36,.15-1.56,.81s.15,1.36,.81,1.56,1.36-.15,1.56-.81-.15-1.36-.81-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106,6.42c.68,.22,1.4-.16,1.62-.84s-.16-1.4-.84-1.62c-.68-.22-1.4,.16-1.62,.84s.16,1.4,.84,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.62,4.29c.7,.22,1.45-.17,1.68-.87s-.17-1.45-.87-1.68-1.45,.17-1.68,.87,.17,1.45,.87,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89.06,3.06c.73,.23,1.5-.17,1.73-.9s-.17-1.5-.9-1.73-1.5,.17-1.73,.9,.17,1.5,.9,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.41,2.78c.75,.24,1.55-.18,1.79-.93s-.18-1.55-.93-1.79c-.75-.24-1.55,.18-1.79,.93s.18,1.55,.93,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.78,3.44c.77,.25,1.6-.18,1.84-.95s-.18-1.6-.95-1.84-1.6,.18-1.84,.95,.18,1.6,.95,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.26,5.03c.8,.25,1.65-.19,1.9-.98s-.19-1.65-.98-1.9c-.8-.25-1.65,.19-1.9,.98s.19,1.65,.98,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.96,7.53c.82,.26,1.69-.19,1.95-1.01s-.19-1.69-1.01-1.95-1.69,.19-1.95,1.01,.19,1.69,1.01,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.98,10.91c.84,.27,1.74-.2,2.01-1.04s-.2-1.74-1.04-2.01c-.84-.27-1.74,.2-2.01,1.04-.27,.84,.2,1.74,1.04,2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.4,15.12c.87,.27,1.79-.2,2.07-1.07s-.2-1.79-1.07-2.07-1.79,.2-2.07,1.07,.2,1.79,1.07,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.31,20.13c.89,.28,1.84-.21,2.12-1.1s-.21-1.84-1.1-2.12c-.89-.28-1.84,.21-2.12,1.1s.21,1.84,1.1,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.8,25.87c.91,.29,1.89-.22,2.18-1.13,.29-.91-.22-1.89-1.13-2.18s-1.89,.22-2.18,1.13,.22,1.89,1.13,2.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 20.49,
    cy: 30.58,
    r: 1.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M14.82,39.28c.96,.3,1.98-.23,2.29-1.19s-.23-1.98-1.19-2.29c-.96-.3-1.98,.23-2.29,1.19s.23,1.98,1.19,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.48,46.81c.98,.31,2.03-.23,2.35-1.22s-.23-2.03-1.21-2.35c-.98-.31-2.03,.23-2.35,1.22s.23,2.03,1.22,2.35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 7.55,
    cy: 52.94,
    r: 1.91,
    transform: "translate(-45.19 44.12) rotate(-72.39)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 4.93,
    cy: 61.17,
    r: 2.19,
    transform: "translate(-54.86 47.36) rotate(-72.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5.39,70.34c.38-1.21-.29-2.51-1.5-2.89-1.21-.38-2.51,.29-2.89,1.5-.38,1.21,.29,2.51,1.5,2.89,1.21,.38,2.51-.29,2.89-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9.59,71.95c1.21,.38,2.5-.28,2.88-1.49s-.29-2.5-1.49-2.88c-1.21-.38-2.5,.28-2.88,1.49-.38,1.21,.28,2.5,1.49,2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.5,63.42c1.15,.36,2.37-.27,2.74-1.42s-.27-2.37-1.42-2.74-2.37,.27-2.74,1.42,.27,2.37,1.42,2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.2,52.62c-.32,1,.24,2.07,1.23,2.38s2.07-.24,2.38-1.23c.32-1-.24-2.07-1.23-2.38-1-.32-2.07,.24-2.38,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20.55,46c.31-.97-.23-2.01-1.2-2.32s-2.01,.23-2.32,1.2c-.31,.97,.23,2.01,1.2,2.32s2.01-.23,2.32-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.74,37.65c-.3,.95,.22,1.96,1.17,2.26,.95,.3,1.96-.22,2.26-1.17s-.22-1.96-1.17-2.26c-.95-.3-1.96,.22-2.26,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.49,29.89c-.92-.29-1.91,.22-2.2,1.14s.22,1.91,1.14,2.2,1.91-.22,2.2-1.14c.29-.92-.22-1.91-1.14-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.7,27.24c.9,.28,1.85-.21,2.14-1.11s-.21-1.85-1.11-2.14c-.9-.28-1.85,.21-2.14,1.11s.21,1.85,1.11,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.63,22.04c.87,.28,1.8-.21,2.08-1.08s-.21-1.8-1.08-2.08-1.8,.21-2.08,1.08,.21,1.8,1.08,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.11,17.69c.85,.27,1.75-.2,2.02-1.04s-.2-1.75-1.04-2.02-1.75,.2-2.02,1.04,.2,1.75,1.04,2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57.05,14.24c.82,.26,1.7-.19,1.96-1.01s-.19-1.7-1.01-1.96-1.7,.19-1.96,1.01,.19,1.7,1.01,1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M65.33,11.75c.79,.25,1.64-.19,1.89-.98s-.19-1.64-.98-1.89-1.64,.19-1.89,.98,.19,1.64,.98,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.84,10.26c.77,.24,1.59-.18,1.83-.95s-.18-1.59-.95-1.83-1.59,.18-1.83,.95,.18,1.59,.95,1.83Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 82.89,
    cy: 8.44,
    r: 1.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.08,10.34c.72,.23,1.48-.17,1.71-.89s-.17-1.48-.89-1.71-1.48,.17-1.71,.89c-.23,.72,.17,1.48,.89,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.57,11.91c.69,.22,1.43-.16,1.65-.85s-.16-1.43-.85-1.65-1.43,.16-1.65,.85,.16,1.43,.85,1.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 108.19,
    cy: 13.25,
    r: 1.27,
    transform: "translate(62.82 112.36) rotate(-72.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.42,15.64c-.64-.2-1.32,.15-1.53,.79-.2,.64,.15,1.32,.79,1.53s1.32-.15,1.53-.79-.15-1.32-.79-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M123.8,20.14c-.61-.2-1.27,.15-1.47,.76s.15,1.27,.76,1.47,1.27-.14,1.47-.76-.15-1.27-.76-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.93,27.56c.56,.18,1.16-.13,1.34-.69s-.13-1.16-.69-1.34-1.16,.13-1.34,.69,.13,1.16,.69,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.23,69.05c-.38,1.2,.28,2.49,1.49,2.87s2.49-.28,2.87-1.49-.28-2.49-1.49-2.87-2.49,.28-2.87,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.41,60.74c-.36,1.14,.27,2.36,1.41,2.72s2.36-.27,2.72-1.41c.36-1.14-.27-2.36-1.41-2.72-1.14-.36-2.36,.27-2.72,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.17,51.58c-.99-.31-2.05,.23-2.36,1.22s.23,2.05,1.22,2.36,2.05-.23,2.36-1.22-.23-2.05-1.22-2.36Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 26.74,
    cy: 45.83,
    r: 1.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.37,37.21c-.93-.3-1.93,.22-2.23,1.15s.22,1.93,1.15,2.23c.93,.3,1.93-.22,2.23-1.15s-.22-1.93-1.15-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.28,34.33c.91,.29,1.87-.21,2.16-1.12,.29-.91-.21-1.87-1.12-2.16s-1.87,.21-2.16,1.12,.21,1.87,1.12,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.01,28.91c.88,.28,1.81-.21,2.09-1.08s-.21-1.81-1.08-2.09c-.88-.28-1.81,.21-2.09,1.08s.21,1.81,1.08,2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.34,22.39c-.27,.85,.2,1.75,1.05,2.02s1.75-.2,2.02-1.05-.2-1.75-1.05-2.02-1.75,.2-2.02,1.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.75,
    cy: 19.42,
    r: 1.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66.57,16.56c-.25,.79,.19,1.64,.98,1.89,.79,.25,1.64-.19,1.89-.98s-.19-1.64-.98-1.89c-.79-.25-1.64,.19-1.89,.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.94,14.32c-.76-.24-1.58,.18-1.82,.94s.18,1.58,.94,1.82,1.58-.18,1.82-.94-.18-1.58-.94-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.68,16.86c.74,.23,1.52-.17,1.75-.91s-.17-1.52-.91-1.75c-.74-.23-1.52,.17-1.75,.91s.17,1.52,.91,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.25,17.76c.71,.22,1.46-.17,1.69-.87s-.17-1.46-.87-1.69-1.46,.17-1.69,.87c-.22,.71,.17,1.46,.87,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M101.61,19.76c.68,.22,1.4-.16,1.62-.84s-.16-1.4-.84-1.62-1.4,.16-1.62,.84,.16,1.4,.84,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.4,20.47c-.65-.21-1.35,.15-1.55,.8s.15,1.35,.8,1.55c.65,.21,1.35-.15,1.55-.8s-.15-1.35-.8-1.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 117.57,
    cy: 25.79,
    r: 1.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.84,29.86c-.56-.18-1.17,.13-1.35,.7s.13,1.17,.7,1.35c.56,.18,1.17-.13,1.35-.7s-.13-1.17-.7-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.73,70.43c.38-1.2-.28-2.48-1.48-2.86-1.2-.38-2.48,.28-2.86,1.48-.38,1.2,.28,2.48,1.48,2.86s2.48-.28,2.86-1.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 26.85,
    cy: 61.48,
    r: 2.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.54,53.06c-.31,.98,.23,2.02,1.21,2.33,.98,.31,2.02-.23,2.33-1.21s-.23-2.02-1.21-2.33-2.02,.23-2.33,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.43,44.65c-.95-.3-1.96,.22-2.26,1.17s.22,1.96,1.17,2.26c.95,.3,1.96-.22,2.26-1.17s-.22-1.96-1.17-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.95,41.51c.92,.29,1.89-.22,2.18-1.13s-.22-1.89-1.13-2.18-1.89,.22-2.18,1.13,.22,1.89,1.13,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.46,32.63c-.88-.28-1.83,.21-2.11,1.09s.21,1.83,1.09,2.11,1.83-.21,2.11-1.09-.21-1.83-1.09-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.66,28.06c-.85-.27-1.76,.2-2.03,1.05s.2,1.76,1.05,2.03c.85,.27,1.76-.2,2.03-1.05s-.2-1.76-1.05-2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M62.45,24.59c-.82-.26-1.7,.19-1.96,1.01s.19,1.7,1.01,1.96c.82,.26,1.7-.19,1.96-1.01s-.19-1.7-1.01-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68.79,23.26c-.25,.79,.19,1.63,.98,1.88,.79,.25,1.63-.19,1.88-.98s-.19-1.63-.98-1.88c-.79-.25-1.63,.19-1.88,.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.09,23.02c.24-.76-.18-1.57-.94-1.81s-1.57,.18-1.81,.94,.18,1.57,.94,1.81,1.57-.18,1.81-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M87.71,21.39c-.73-.23-1.5,.17-1.73,.9s.17,1.5,.9,1.73,1.5-.17,1.73-.9-.17-1.5-.9-1.73Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.77,
    cy: 24.08,
    r: 1.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.33,25.47c-.66-.21-1.37,.16-1.58,.82s.16,1.37,.82,1.58c.66,.21,1.37-.16,1.58-.82s-.16-1.37-.82-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.03,29.27c-.63-.2-1.31,.15-1.51,.78s.15,1.31,.78,1.51,1.31-.15,1.51-.78-.15-1.31-.78-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.08,34.21c-.57-.18-1.18,.13-1.36,.7s.13,1.18,.7,1.36,1.18-.13,1.36-.7-.13-1.18-.7-1.36Z"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.41,92.94l-15.13,8.05c-2.39-4.88-5.34-7.32-8.86-7.32-1.68,0-3.12,.56-4.31,1.67-1.19,1.11-1.79,2.53-1.79,4.27,0,3.04,3.52,6.05,10.57,9.03,9.7,4.18,16.24,8.02,19.6,11.55,3.36,3.52,5.04,8.27,5.04,14.23,0,7.64-2.82,14.04-8.46,19.19-5.48,4.88-12.09,7.32-19.84,7.32-13.28,0-22.69-6.48-28.22-19.44l15.62-7.24c2.17,3.8,3.82,6.21,4.96,7.24,2.22,2.06,4.88,3.09,7.97,3.09,6.18,0,9.27-2.82,9.27-8.46,0-3.25-2.39-6.29-7.16-9.11-1.84-.92-3.69-1.81-5.53-2.68-1.84-.87-3.71-1.76-5.61-2.68-5.31-2.6-9.05-5.21-11.22-7.81-2.77-3.31-4.15-7.56-4.15-12.77,0-6.88,2.36-12.58,7.08-17.08,4.83-4.5,10.68-6.75,17.57-6.75,10.14,0,17.67,5.23,22.61,15.7Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.11,181.14H4.1v5.98H13.82v3.53H4.1v8.31H14.11v3.53H.33v-24.88H14.11v3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.84,177.61v14.99c0,2.14,.35,3.7,1.05,4.69,1.05,1.43,2.52,2.14,4.42,2.14s3.39-.71,4.43-2.14c.7-.96,1.05-2.52,1.05-4.69v-14.99h3.77v16.02c0,2.62-.82,4.78-2.46,6.48-1.84,1.89-4.11,2.84-6.8,2.84s-4.95-.95-6.78-2.84c-1.64-1.7-2.46-3.86-2.46-6.48v-16.02h3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.02,191.89l7.74,10.6h-4.61l-7.14-10.18h-.68v10.18h-3.77v-24.88h4.42c3.3,0,5.69,.62,7.15,1.85,1.62,1.38,2.43,3.19,2.43,5.45,0,1.76-.51,3.28-1.52,4.54-1.01,1.27-2.35,2.08-4.01,2.43Zm-4.69-2.85h1.2c3.57,0,5.36-1.36,5.36-4.08,0-2.55-1.74-3.82-5.21-3.82h-1.34v7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.69,189.94c0-3.5,1.29-6.51,3.87-9.02,2.57-2.51,5.65-3.77,9.26-3.77s6.61,1.27,9.16,3.8c2.56,2.54,3.84,5.58,3.84,9.14s-1.28,6.61-3.85,9.1c-2.58,2.5-5.69,3.75-9.34,3.75-3.23,0-6.12-1.11-8.69-3.34-2.83-2.46-4.24-5.68-4.24-9.67Zm3.8,.05c0,2.75,.93,5.01,2.78,6.78,1.85,1.77,3.98,2.66,6.39,2.66,2.62,0,4.83-.9,6.64-2.71,1.8-1.83,2.7-4.05,2.7-6.67s-.89-4.88-2.67-6.67c-1.77-1.8-3.96-2.71-6.57-2.71s-4.8,.9-6.59,2.71c-1.79,1.78-2.69,3.99-2.69,6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.33,192.39v10.1h-3.77v-24.88h4.27c2.09,0,3.67,.15,4.74,.44,1.08,.29,2.03,.84,2.85,1.64,1.44,1.4,2.15,3.16,2.15,5.29,0,2.28-.77,4.08-2.3,5.42-1.53,1.33-3.6,2-6.2,2h-1.75Zm0-3.48h1.41c3.46,0,5.19-1.33,5.19-3.98s-1.79-3.85-5.36-3.85h-1.25v7.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.24,181.14h-10.02v5.98h9.73v3.53h-9.73v8.31h10.02v3.53h-13.79v-24.88h13.79v3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.87,196.45h-10.7l-2.78,6.04h-4.06l12.36-26.44,11.93,26.44h-4.13l-2.62-6.04Zm-1.54-3.53l-3.71-8.46-3.88,8.46h7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.75,202.49v-26.57l18.22,18.98v-17.29h3.77v26.4l-18.22-18.93v17.42h-3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.43,181.14h-8.71v5.98h8.4v3.53h-8.4v11.84h-3.77v-24.88h12.48v3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.59,189.94c0-3.5,1.29-6.51,3.87-9.02,2.57-2.51,5.65-3.77,9.26-3.77s6.61,1.27,9.16,3.8c2.56,2.54,3.84,5.58,3.84,9.14s-1.28,6.61-3.85,9.1c-2.58,2.5-5.69,3.75-9.34,3.75-3.23,0-6.12-1.11-8.69-3.34-2.83-2.46-4.24-5.68-4.24-9.67Zm3.8,.05c0,2.75,.93,5.01,2.78,6.78,1.85,1.77,3.98,2.66,6.39,2.66,2.62,0,4.83-.9,6.64-2.71,1.8-1.83,2.7-4.05,2.7-6.67s-.89-4.88-2.67-6.67c-1.77-1.8-3.96-2.71-6.57-2.71s-4.8,.9-6.59,2.71c-1.79,1.78-2.69,3.99-2.69,6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.21,189.94c0-3.5,1.29-6.51,3.87-9.02,2.57-2.51,5.65-3.77,9.26-3.77s6.61,1.27,9.16,3.8c2.56,2.54,3.84,5.58,3.84,9.14s-1.28,6.61-3.85,9.1c-2.58,2.5-5.69,3.75-9.34,3.75-3.23,0-6.12-1.11-8.69-3.34-2.83-2.46-4.24-5.68-4.24-9.67Zm3.8,.05c0,2.75,.93,5.01,2.78,6.78,1.85,1.77,3.98,2.66,6.39,2.66,2.62,0,4.83-.9,6.64-2.71,1.8-1.83,2.7-4.05,2.7-6.67s-.89-4.88-2.67-6.67c-1.77-1.8-3.96-2.71-6.57-2.71s-4.8,.9-6.59,2.71c-1.79,1.78-2.69,3.99-2.69,6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.07,202.49v-24.88h5.24c2.51,0,4.5,.25,5.96,.74,1.56,.48,2.98,1.31,4.26,2.47,2.58,2.34,3.87,5.42,3.87,9.23s-1.34,6.92-4.03,9.28c-1.35,1.18-2.76,2-4.24,2.46-1.38,.46-3.34,.69-5.87,.69h-5.18Zm3.77-3.53h1.7c1.69,0,3.1-.18,4.22-.53,1.12-.38,2.14-.97,3.04-1.79,1.86-1.69,2.78-3.88,2.78-6.59s-.92-4.94-2.75-6.64c-1.65-1.51-4.08-2.27-7.3-2.27h-1.7v17.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M316.49,181.32l-3.06,1.8c-.57-.99-1.12-1.63-1.63-1.93-.54-.34-1.24-.52-2.09-.52-1.05,0-1.92,.29-2.61,.89-.69,.58-1.04,1.31-1.04,2.19,0,1.21,.91,2.19,2.72,2.93l2.49,1.02c2.03,.82,3.51,1.81,4.45,2.99,.94,1.18,1.41,2.62,1.41,4.33,0,2.29-.77,4.18-2.3,5.67-1.54,1.5-3.46,2.26-5.75,2.26s-3.96-.64-5.37-1.92c-1.39-1.28-2.26-3.08-2.61-5.4l3.82-.84c.17,1.46,.47,2.47,.91,3.03,.78,1.07,1.91,1.61,3.4,1.61,1.18,0,2.15-.39,2.93-1.18,.78-.78,1.17-1.78,1.17-2.98,0-.48-.07-.93-.2-1.33-.14-.4-.35-.77-.63-1.11-.29-.34-.65-.66-1.11-.95-.45-.29-.99-.58-1.62-.85l-2.41-1c-3.42-1.44-5.13-3.55-5.13-6.32,0-1.87,.72-3.43,2.15-4.69,1.43-1.27,3.22-1.9,5.36-1.9,2.88,0,5.13,1.4,6.75,4.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M336.1,196.45h-10.7l-2.78,6.04h-4.06l12.36-26.44,11.93,26.44h-4.13l-2.62-6.04Zm-1.54-3.53l-3.71-8.46-3.88,8.46h7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M358.45,181.14h-8.71v5.98h8.4v3.53h-8.4v11.84h-3.77v-24.88h12.48v3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M376.61,181.14h-10.02v5.98h9.73v3.53h-9.73v8.31h10.02v3.53h-13.79v-24.88h13.79v3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.46,181.14v21.35h-3.77v-21.35h-5.75v-3.53h15.25v3.53h-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.22,191.75l-8.16-14.13h4.34l5.71,9.94,5.73-9.94h4.34l-8.19,14.13v10.75h-3.77v-10.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M443.97,196.45h-10.7l-2.78,6.04h-4.06l12.36-26.44,11.93,26.44h-4.13l-2.62-6.04Zm-1.54-3.53l-3.71-8.46-3.88,8.46h7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M456.65,177.61v14.99c0,2.14,.35,3.7,1.05,4.69,1.05,1.43,2.52,2.14,4.42,2.14s3.39-.71,4.43-2.14c.7-.96,1.05-2.52,1.05-4.69v-14.99h3.77v16.02c0,2.62-.82,4.78-2.46,6.48-1.84,1.89-4.11,2.84-6.8,2.84s-4.95-.95-6.78-2.84c-1.64-1.7-2.46-3.86-2.46-6.48v-16.02h3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M484.27,181.14v21.35h-3.77v-21.35h-5.75v-3.53h15.25v3.53h-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M497.13,187.35h10.78v-9.73h3.77v24.88h-3.77v-11.62h-10.78v11.62h-3.77v-24.88h3.77v9.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M516.42,189.94c0-3.5,1.29-6.51,3.87-9.02,2.57-2.51,5.65-3.77,9.26-3.77s6.61,1.27,9.16,3.8c2.56,2.54,3.83,5.58,3.83,9.14s-1.28,6.61-3.85,9.1c-2.58,2.5-5.69,3.75-9.34,3.75-3.23,0-6.12-1.11-8.69-3.34-2.83-2.46-4.24-5.68-4.24-9.67Zm3.8,.05c0,2.75,.93,5.01,2.78,6.78,1.84,1.77,3.98,2.66,6.39,2.66,2.62,0,4.83-.9,6.63-2.71,1.8-1.83,2.7-4.05,2.7-6.67s-.89-4.88-2.67-6.67c-1.77-1.8-3.96-2.71-6.57-2.71s-4.8,.9-6.59,2.71c-1.79,1.78-2.69,3.99-2.69,6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M555.75,191.89l7.74,10.6h-4.61l-7.14-10.18h-.68v10.18h-3.77v-24.88h4.42c3.3,0,5.69,.62,7.15,1.85,1.62,1.38,2.43,3.19,2.43,5.45,0,1.76-.51,3.28-1.52,4.54-1.01,1.27-2.35,2.08-4.01,2.43Zm-4.69-2.85h1.2c3.57,0,5.36-1.36,5.36-4.08,0-2.55-1.74-3.82-5.21-3.82h-1.34v7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M571.01,177.61v24.88h-3.77v-24.88h3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M583.91,181.14v21.35h-3.77v-21.35h-5.75v-3.53h15.25v3.53h-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M599.67,191.75l-8.16-14.13h4.34l5.71,9.94,5.73-9.94h4.34l-8.19,14.13v10.75h-3.77v-10.75Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 491.82,
    y: 79.04,
    width: 120.01,
    height: 80.01
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "549.27 96.47 551.8 94.63 554.34 96.47 553.37 93.49 555.94 91.64 552.78 91.64 551.8 88.61 550.83 91.64 547.67 91.64 550.24 93.49 549.27 96.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "536.17 100 538.7 98.15 541.23 100 540.27 97.01 542.84 95.16 539.67 95.16 538.7 92.13 537.73 95.16 534.56 95.16 537.13 97.01 536.17 100"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "529.11 101.74 528.14 104.77 524.97 104.77 527.54 106.62 526.58 109.61 529.11 107.76 531.64 109.61 530.68 106.62 533.25 104.77 530.08 104.77 529.11 101.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "525.59 120.85 528.12 122.69 527.16 119.71 529.73 117.86 526.56 117.86 525.59 114.83 524.62 117.86 521.45 117.86 524.02 119.71 523.06 122.69 525.59 120.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "530.08 130.99 529.11 127.96 528.14 130.99 524.97 130.99 527.54 132.83 526.58 135.82 529.11 133.97 531.64 135.82 530.68 132.83 533.25 130.99 530.08 130.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "539.69 140.59 538.72 137.57 537.75 140.6 534.58 140.59 537.15 142.44 536.19 145.43 538.72 143.58 541.25 145.43 540.29 142.44 542.86 140.59 539.69 140.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "552.78 144.08 551.81 141.05 550.84 144.08 547.67 144.08 550.24 145.92 549.27 148.91 551.81 147.06 554.34 148.91 553.38 145.92 555.95 144.08 552.78 144.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "565.87 140.59 564.9 137.57 563.93 140.6 560.76 140.59 563.33 142.44 562.36 145.43 564.9 143.58 567.43 145.43 566.46 142.44 569.04 140.59 565.87 140.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "575.48 130.99 574.5 127.96 573.53 130.99 570.37 130.99 572.94 132.83 571.97 135.82 574.5 133.97 577.04 135.82 576.07 132.83 578.64 130.99 575.48 130.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "582.12 117.82 578.95 117.82 577.98 114.79 577.01 117.83 573.84 117.82 576.41 119.67 575.45 122.66 577.98 120.81 580.51 122.66 579.55 119.67 582.12 117.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "571.97 109.57 574.5 107.72 577.04 109.57 576.07 106.58 578.64 104.73 575.48 104.73 574.5 101.7 573.53 104.74 570.36 104.73 572.94 106.58 571.97 109.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "564.93 92.13 563.96 95.17 560.79 95.16 563.36 97.01 562.4 100 564.94 98.15 567.47 100 566.5 97.01 569.07 95.16 565.9 95.16 564.93 92.13"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.7,135.77c-4.42,5.02-10.88,8.2-18.1,8.2-10.62,0-19.63-6.87-22.86-16.4h63.42c.48-2.51,.74-5.1,.74-7.75,0-22.81-18.49-41.3-41.3-41.3s-41.3,18.49-41.3,41.3,18.49,41.3,41.3,41.3c17.15,0,31.86-10.46,38.1-25.35h-20Zm-18.1-40.1c10.62,0,19.63,6.87,22.86,16.4h-45.71c3.23-9.53,12.23-16.4,22.86-16.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.04,22.18c-2.53,3.82-3.94,8.46-3.94,8.46-1.63,5.36-1.57,10.01-1.31,12.9v35.51h-6.57v17.25h6.57v62.76h18.57v-62.76h20.13v-17.25h-20.13v-30.99c0-4.21,.24-7.53,.71-9.98,.04-.2,.08-.4,.13-.59,.09-.41,.19-.8,.3-1.15,0-.01,0-.02,.01-.04,.14-.47,.3-.9,.47-1.28,2.4-5.87,8.16-10.01,14.9-10.01,1.25,0,2.45,.16,3.62,.42V8.42c-16.83-2.79-28.53,6.36-33.43,13.76Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M445.81,79.04v6.93c-6.38-4.13-13.98-6.54-22.15-6.54-22.55,0-40.84,18.28-40.84,40.84s18.28,40.84,40.84,40.84c8.17,0,15.77-2.41,22.15-6.54v4.47h18.69V79.04h-18.69Zm-21.84,65.42c-12.53,0-22.84-9.53-24.07-21.75-.08-.8-.12-1.62-.12-2.44s.04-1.64,.12-2.44c1.22-12.21,11.53-21.75,24.07-21.75,13.36,0,24.19,10.83,24.19,24.19s-10.83,24.19-24.19,24.19Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEfsaLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "EFSA_logo.4c50a58.svg";